import http from '../api/http'

export default {
  all: () => http.get('/products/all', { timeout: 60000 }),
  countByBarcode: (barcode) => http.get('/products/count-by-barcode', { params: { barcode } }),
  findByTag: (tag) => http.get('/products/all', { params: { tag } }),
  findAllByBarcode: (barcode) => http.get('/products/find-all-by-barcode', { params: { barcode } }),
  findByBarcode: (barcode) => http.get('/products/find-by-barcode', { params: { barcode } }),
  getLiquidAlternatives: (productId) => http.get('/products/get-liquid-alternatives', { params: { productId } }),
  list: () => http.get('/products/list'),
  stocks: () => http.get('/products/stocks')
}



// WEBPACK FOOTER //
// ./src/services/products.js